module.exports = __webpack_public_path__ + "static/media/invoice_logo.e6f4a57a.jpg";